import { render, staticRenderFns } from "./actionsItem.vue?vue&type=template&id=b95bb3c2&"
import script from "./actionsItem.vue?vue&type=script&lang=js&"
export * from "./actionsItem.vue?vue&type=script&lang=js&"
import style0 from "./actionsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports